export default function FilterGender() {
  return (
    <div className="bg-white rounded-xl p-4 shadow flex gap-3 justify-center">
      <button className="px-4 py-2 rounded-lg border text-sm hover:bg-gray-100">👩 ผู้หญิง</button>
      <button className="px-4 py-2 rounded-lg border text-sm hover:bg-gray-100">👨 ผู้ชาย</button>
      <button className="px-4 py-2 rounded-lg border text-sm hover:bg-gray-100">👥 กลุ่มอายุ</button>
    </div>
  );
}
